import { Hidable } from "../model/types";
import { isHidden } from "./is-hidden";

/**
 * Есть ли среди значений закрытое защитой.
 *
 * Нужно формам редактирования: `valueOrNull` превращает скрытое значение в пустоту,
 * а форма отправляет весь свой набор полей независимо от того, что правил пользователь.
 * Без этой проверки сохранение молча затирает данные, которых человеку не показали.
 *
 * Принимает именно массив, а не список аргументов: с `...values` тип схлопывался до
 * `unknown`, и забытый спред — `hasHidden(approvers)` вместо `hasHidden(...approvers)` —
 * компилировался, всегда возвращая `false`, то есть беззвучно снимал защиту.
 */
export function hasHidden(values: Hidable<unknown>[]): boolean {
  return values.some(isHidden);
}
